import { FC } from 'react';

interface ReadyIconProps {
  dotColor?: string;
}
export const ReadyIcon: FC<ReadyIconProps> = ({ dotColor = 'primary' }) => (
  <>
    <div
      data-e2e="ready-icon"
      className="d-flex align-items-center justify-content-center rounded-pill"
      style={{ height: 20, width: 20, border: '0.15em solid' }}
    >
      <div className={`d-flex rounded-pill ready-ico bg-${dotColor}`} style={{ height: 6, width: 6 }}></div>
    </div>
  </>
);

export const Spinner = <div data-e2e="spinner-icon" className="spinner" style={{ height: 20, width: 20 }} />;

export const CircularCountdown = (
  <svg
    data-e2e="circular-countdown-icon"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    className="circular-countdown rounded-pill"
  >
    <circle className="bg"></circle>
    <circle className="fg"></circle>
  </svg>
);

export const WarningIcon = <i className="text-warning icon icon-sm">warning</i>;
